import 'css-chunksrc/client/pages/zonePage/wbsPage/filters/styles.scss';export default {
  "filters": "_filters_1zuo0_1",
  "resetButton": "_resetButton_1zuo0_9",
  "label": "_label_1zuo0_17",
  "section": "_section_1zuo0_24"
};